/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IDeviceCredential extends IEntity {
        deviceHref: string;
        name: string;
        value: string;
        type: string;
        typeHtml?: string;
        allowSave?: boolean;
    }

    export class DeviceCredential implements IDeviceCredential {
        public deviceHref: string;
        public href: string;
        public name: string;
        public value: string;
        public type: string;

        public static Empty(): DeviceCredential {
            return new DeviceCredential();
        }

        public static Burnish(credential: IDeviceCredential): DeviceCredential {
            return credential;
        }

        constructor() {
            // do nothing
        }

    }

    export interface IDeviceCredentialSpec {
        name: string;
        "default": string;
        type: string;
    }
}